import React from 'react';
import { Box, Card, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { LenderApprovalTermsSummaryViewModel } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { APPROVAL_TERMS_SUMMARY_CARDS } from '../../../../constants';

interface Props {
  summary: LenderApprovalTermsSummaryViewModel | null;
  loading?: boolean;
}

export const ApprovalTermsSummaryCards = ({ summary, loading }: Props) => (
  <CardContainer title="Summary cards">
    <Box
      sx={{
        gap: '1rem',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(3, 1fr)' },
      }}
    >
      {APPROVAL_TERMS_SUMMARY_CARDS.map(({ key, title, formatValue, formatRange }) => {
        const metric = summary?.[key] ?? null;

        return (
          <Card key={key} variant="outlined" sx={{ p: 2 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography fontWeight={500}>{title}:</Typography>
              <Typography variant="h6">
                {loading ? <Skeleton width={60} /> : metric ? formatValue(metric.avg) : '—'}
              </Typography>
            </Stack>

            <Divider sx={{ my: 1 }} />

            <Typography variant="body2" color="text.secondary">
              {loading ? <Skeleton width={120} /> : metric ? formatRange(metric.min, metric.max) : ''}
            </Typography>
          </Card>
        );
      })}
    </Box>
  </CardContainer>
);
